import React, { ReactNode } from "react"
import styles from "./FormAccordion.module.scss"
import { ClassProps } from "../../utility/common/props"
import cn from "classnames"
import { Accordion } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleUp } from "@fortawesome/pro-light-svg-icons"
import AccordionToggle from "./AccordionToggle"
import Spinner from "../Spinner/Spinner"
import { useOpenedState } from "../../hooks/useOpenedState"
import { faAngleDown } from "@fortawesome/pro-light-svg-icons/faAngleDown"
import { testId } from "../../utility/tests/testId/common"

export interface FormAccordionProps extends ClassProps {
    disabled?: boolean
    headerClassName?: string
    title: string
    children: ReactNode
    headerElement?: JSX.Element
    loading?: boolean
    initialOpened?: boolean
    size?: "lg" | "md"
    eventKey?: string
    headerTitleClassName?: string
    toggleClassName?: string
    id?: string
    accordionTestId?: string
    accordionToggleTestId?: string
}

const FormAccordion: React.FC<FormAccordionProps> = props => {
    const {
        id,
        className,
        disabled,
        title,
        headerElement,
        children,
        loading = false,
        initialOpened = false,
        size = "md",
        eventKey = "0",
        headerClassName,
        headerTitleClassName,
        toggleClassName,
        accordionTestId = testId.accordion,
        accordionToggleTestId = testId.accordionToggle
    } = props
    const [opened, toggleOpen] = useOpenedState(initialOpened)

    return (
        <Accordion
            id={id}
            className={cn(className, styles.formAccordion)}
            defaultActiveKey={initialOpened ? "0" : undefined}
            data-testid={accordionTestId}
        >
            <AccordionToggle disabled={!!disabled} eventKey={eventKey} onToggle={toggleOpen}>
                <div
                    className={cn(
                        styles.formAccordion__header,
                        size === "lg" && styles.formAccordion__header_lg,
                        headerClassName
                    )}
                >
                    <div
                        className={cn(
                            styles.formAccordion__title,
                            disabled ? styles.formAccordion__title_disabled : undefined,
                            headerTitleClassName
                        )}
                    >
                        {title}
                        {loading && <Spinner className={styles.formAccordion__spinner} />}
                    </div>
                    {headerElement && <div className={styles.formAccordion__headerElement}>{headerElement}</div>}
                    {!disabled ? (
                        <div
                            className={cn(styles.formAccordion__toggle, toggleClassName)}
                            data-testid={accordionToggleTestId}
                        >
                            <FontAwesomeIcon
                                icon={opened ? faAngleUp : faAngleDown}
                                size={size === "lg" ? "2x" : "lg"}
                            />
                        </div>
                    ) : undefined}
                </div>
            </AccordionToggle>
            <Accordion.Collapse eventKey={eventKey}>
                <div className={styles.formAccordion__body}>{children}</div>
            </Accordion.Collapse>
        </Accordion>
    )
}

export default FormAccordion
